/**
 * Guest (unsigned) Get Quote journey — public /quote/* routes.
 */
import { CUSTOMER_PRODUCTS } from '@/constants/customerProducts';
import { isCustomerPaEnabled } from '@/utils/paChannel';
import { isCustomerTravelEnabled } from '@/utils/travelChannel';
import { isCustomerMotorV2Enabled } from '@/utils/motorChannel';

export const GUEST_SESSION_KEY = 'guest';

export const GUEST_QUOTE_ROUTES = {
  products: 'GuestProductSelect',
  motorStart: 'GuestMotorStart',
  travelPlans: 'GuestTravelPlanSelect',
  paPlans: 'GuestPaPlanSelect',
};

/** After login, land on authenticated buy/apply with the same quote query. */
export function guestBuyRouteForProduct(product, query = {}) {
  switch (product) {
    case 'motor':
      return { name: 'CustomerMotorApply', query };
    case 'travel':
      return { name: 'CustomerTravelSale', query };
    case 'pa':
      return { name: 'CustomerPaSale', query };
    default:
      return { name: 'CustomerProductSelect' };
  }
}

/**
 * Send guest to Sign In, then return to the authenticated buy route.
 */
export function redirectGuestToBuy(router, buyRoute) {
  const resolved = router.resolve(buyRoute);
  const returnUrl = `${window.location.origin}${resolved.href}`;
  return router.push({
    name: 'SignIn',
    query: { portal: 'customer', r: returnUrl },
  });
}

export function guestQuoteProducts() {
  const motorV2 = isCustomerMotorV2Enabled();
  const paLive = isCustomerPaEnabled();
  const travelLive = isCustomerTravelEnabled();

  return CUSTOMER_PRODUCTS.map((p) => {
    if (p.id === 'motor' && motorV2) {
      return { ...p, route: { name: GUEST_QUOTE_ROUTES.motorStart } };
    }
    if (p.id === 'pa' && paLive) {
      return { ...p, route: { name: GUEST_QUOTE_ROUTES.paPlans } };
    }
    if (p.id === 'travel' && travelLive) {
      return { ...p, route: { name: GUEST_QUOTE_ROUTES.travelPlans } };
    }
    if (p.id === 'motor' && !motorV2) {
      return { ...p, route: { name: 'Request', query: { product: 'motor' } } };
    }
    return { ...p, route: p.live ? p.route : null };
  });
}
